import { render, staticRenderFns } from "./Speaking.vue?vue&type=template&id=49499822&scoped=true&"
import script from "./Speaking.vue?vue&type=script&lang=js&"
export * from "./Speaking.vue?vue&type=script&lang=js&"
import style0 from "./Speaking.vue?vue&type=style&index=0&id=49499822&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49499822",
  null
  
)

export default component.exports